// // i18n.js
// import Vue from 'vue';
// import VueI18n from 'vue-i18n';

// // Vue.use(VueI18n);

// // const messages = {
// //   en: {
// //     greeting: 'Hello, World!',
// //     welcome: 'Welcome to the Vue.js app'
// //   },
// //   fr: {
// //     greeting: 'Bonjour le monde!',
// //     welcome: 'Bienvenue dans l\'application Vue.js'
// //   },
// //   zh: {
// //     greeting: '你好，世界！',
// //     welcome: '欢迎来到 Vue.js 应用'
// //   }
// // };

// // const i18n = new VueI18n({
// //   locale: 'en', // 默认语言
// //   messages
// // });

// // export default i18n;

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementEsLocale from 'element-ui/lib/locale/lang/es'// element-ui lang
// import enLocale from './en'
import zhLocale from './zh'
// import esLocale from './es'

Vue.use(VueI18n)

const messages = {
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

// const messages = {
//   en: {
//     greeting: 'Hello, World!',
//     welcome: 'Welcome to the Vue.js app'
//   },
//   fr: {
//     greeting: 'Bonjour le monde!',
//     welcome: 'Bienvenue dans l\'application Vue.js'
//   },
//   zh: {
//     login: {
//       getpwdtitle: 'ss'
//     },
//     greeting: '你好，世界！',
//     welcome: '欢迎来到 Vue.js 应用'
//   }
// };
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || 'zh',
  // set locale messages
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js